// The night's clock: seconds into the night to and from wall-clock text, in
// the facility's zone and the page's language.
export class NightClock {
  private readonly startsAtMs: number;
  private readonly time: Intl.DateTimeFormat;
  private readonly dateTime: Intl.DateTimeFormat;

  constructor(startsAt: string, timeZone: string, locale = document.documentElement.lang || undefined) {
    this.startsAtMs = new Date(startsAt).getTime();
    this.time = new Intl.DateTimeFormat(locale, { hour: "numeric", minute: "2-digit", timeZone });
    this.dateTime = new Intl.DateTimeFormat(locale, {
      weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone,
    });
  }

  timeAt(seconds: number): string {
    return this.time.format(this.at(seconds));
  }

  dateTimeAt(seconds: number): string {
    return this.dateTime.format(this.at(seconds));
  }

  isoAt(seconds: number): string {
    return this.at(seconds).toISOString();
  }

  // Seconds into the night right now, by the browser's clock.
  elapsed(): number {
    return Math.floor((Date.now() - this.startsAtMs) / 1000);
  }

  private at(seconds: number): Date {
    return new Date(this.startsAtMs + seconds * 1000);
  }
}
